import failedIcon from './failed-icon.svg'
import successIcon from './success-icon.svg'
import warningIcon from './warning-icon.svg'

export const notificationIcons = {
  failedIcon,
  successIcon,
  warningIcon,
}
